import { getDoc, doc } from "firebase/firestore";
import { db } from "../firebase-config"; 

export const fetchUserDetails = async (userId) => {
  try {
    const userRef = doc(db, "users", userId);
    const userDoc = await getDoc(userRef);
    if (userDoc.exists()) {
      const userData = userDoc.data();
      return {
        isAdmin: userData.isAdmin,
        userType: userData.userType
      };
    }
  } catch (error) {
    console.error("Error fetching user details:", error);
    return { isAdmin: false, userType: null };
  }
};

